module.exports = __webpack_public_path__ + "media/images/lp_pikawaka-logo-057abcb9a7488f4b20b725a4d6112596.webp";